import { FC, useState } from "react";
import HidePassword from "./HidePassword";
import ShowPassword from "./ShowPassword";

export const PasswordInput = ({
  value,
  onChange,
  placeholder,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="password">
      <input
        className={`password__input input `}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder || "Password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      ></input>
      <button
        className="password__button"
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
      >
        {showPassword ? (
          <HidePassword></HidePassword>
        ) : (
          <ShowPassword></ShowPassword>
        )}
      </button>
    </div>
  );
};
